import React, { useState } from 'react';
import './Chat.css';

function GroupEditModal({ group, allUsers, currentUserId, onClose, onSave, onLeave }) {
  const currentMemberIds = new Set((group.members || []).map(m => m._id || m));
  const [selected, setSelected] = useState(new Set(currentMemberIds));
  const [error, setError]       = useState('');
  const [saving, setSaving]     = useState(false);

  const toggle = (id) => {
    if (id === currentUserId) return; // can't remove yourself here — use Leave
    setSelected(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    try {
      await onSave({ members: [...selected] });
      onClose();
    } catch (e) {
      setError(e.response?.data?.msg || 'Error saving group.');
      setSaving(false);
    }
  };

  const handleLeave = async () => {
    setSaving(true);
    try {
      await onLeave();
      onClose();
    } catch (e) {
      setError(e.response?.data?.msg || 'Error leaving group.');
      setSaving(false);
    }
  };

  const others = allUsers.filter(u => u._id !== currentUserId);

  return (
    <div className="modal-backdrop" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <h3>Edit Group — {group.name}</h3>
        <div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 4 }}>Members</div>
          <div className="member-list">
            {others.map(u => (
              <label key={u._id} className="member-list-item">
                <input
                  type="checkbox"
                  checked={selected.has(u._id)}
                  onChange={() => toggle(u._id)}
                />
                <span className={`chat-sender role-${u.role}`}>{u.username}</span>
                <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{u.role}</span>
              </label>
            ))}
          </div>
        </div>
        {error && <div className="form-error">{error}</div>}
        <div className="modal-actions" style={{ justifyContent: 'space-between' }}>
          <button
            className="btn-secondary"
            style={{ color: 'var(--red)' }}
            onClick={handleLeave}
            disabled={saving}
          >
            Leave Group
          </button>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
            <button className="btn-primary" onClick={handleSave} disabled={saving}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroupEditModal;
